import { defineStore } from 'pinia'
import { activateDarkMode, deactivateDarkMode } from '@/assets/js/dark-mode'

export const useUiStore = defineStore('ui', {
    state: () => ({
        isRTL: false,
        showNavbar: true,
        showFooter: true,
        showConfig: false,
        hideConfigButton: false,
        isNavFixed: false,
        isAbsolute: false,
        layout: 'default',
        showSidenav: true,
        darkMode: false,
        sidebarType: 'bg-white',
        sidebarColor: 'primary',
        isPinned: false,
        showNavs: true,
        showMain: true,
        mcolor: ''
    }),

    actions: {
        toggleConfigurator() {
            this.showConfig = !this.showConfig
        },

        sidebarMinimize() {
            const sidenav_show = document.querySelector('#app')
            if (!sidenav_show) return

            if (this.isPinned) {
                sidenav_show.classList.add('g-sidenav-hidden')
                sidenav_show.classList.remove('g-sidenav-pinned')
                this.isPinned = false
            } else {
                sidenav_show.classList.add('g-sidenav-pinned')
                sidenav_show.classList.remove('g-sidenav-hidden')
                this.isPinned = true
            }
        },

        navbarFixed() {
            this.isNavFixed = !this.isNavFixed
        },

        setDarkMode(val) {
            this.darkMode = val
            this.sidebarType = val ? 'bg-default' : 'bg-white'
            val ? activateDarkMode() : deactivateDarkMode()
            localStorage.setItem('darkMode', val)
        },

        setSidebarType(type) {
            this.sidebarType = this.darkMode ? 'bg-default' : type
            localStorage.setItem('sidebarType', type)
        },

        setSidebarColor(color) {
            this.sidebarColor = color
            localStorage.setItem('sidebarColor', color)
        },

        toggleSidebarColor(payload) {
            this.setSidebarType(payload)
        },

        setRTL(val) {
            this.isRTL = val
        },

        restoreFromLocalStorage() {
            const darkMode = localStorage.getItem('darkMode')
            const sidebarType = localStorage.getItem('sidebarType')
            const sidebarColor = localStorage.getItem('sidebarColor')

            if (darkMode !== null) this.setDarkMode(darkMode === 'true')
            if (sidebarType) this.setSidebarType(sidebarType)
            if (sidebarColor) this.setSidebarColor(sidebarColor)
        }
    }
})
